import { createFileRoute } from "@tanstack/react-router"
import Dashboard from "@/app/home/Dashboard"

export const Route = createFileRoute("/home")({
  component: Dashboard,
})
